// src/TermsOfService.js

import React from "react";
import "./HomePage.css";
import SiteFooter from "./components/SiteFooter.js";
import PageHeader from "./components/PageHeader.js";

export default function TermsOfService() {
  return (
    <div className="min-h-screen flex flex-col">
      <PageHeader />
    <main id="main-content" className="max-w-3xl mx-auto p-6 flex-1" tabIndex={-1}>
      <h1 className="text-4xl font-bold mb-6">Terms of Service</h1>

      <p className="mb-4">
        These Terms of Service (“Terms”) govern your access to and use of our
        website, products, and services (“Services”). By using our Services, you
        agree to comply with these Terms. If you do not agree, please discontinue
        use of our platform.
      </p>

      <h2 className="text-2xl font-semibold mt-6 mb-3">1. Use of Services</h2>
      <p className="mb-4">
        You must be at least 13 years old to use our Services unless a higher
        minimum age is required in your region. You agree to use our Services only
        for lawful purposes and in compliance with all applicable laws.
      </p>

      <h2 className="text-2xl font-semibold mt-6 mb-3">2. User Accounts</h2>
      <p className="mb-4">
        You are responsible for maintaining the confidentiality of your account
        information and for all activities that occur under your account. You
        agree to notify us immediately of any unauthorized access or security
        breach.
      </p>

      <h2 className="text-2xl font-semibold mt-6 mb-3">3. Prohibited Activities</h2>
      <p className="mb-4">You agree not to:</p>
      <ul className="list-disc ml-6 space-y-2 mb-4">
        <li>Use the Services for illegal or harmful activities</li>
        <li>Attempt to access accounts that do not belong to you</li>
        <li>Interfere with the operation or security of the platform</li>
        <li>Upload malicious code or engage in fraudulent behavior</li>
      </ul>

      <h2 className="text-2xl font-semibold mt-6 mb-3">4. Intellectual Property</h2>
      <p className="mb-4">
        All content, trademarks, logos, and materials provided through our
        Services are owned by us or licensed to us. You may not reproduce,
        distribute, or modify any content without prior written permission.
      </p>

      <h2 className="text-2xl font-semibold mt-6 mb-3">5. Payments & Subscriptions</h2>
      <p className="mb-4">
        Some features may require payment or subscription. By purchasing a
        subscription, you authorize us to charge your payment method on a
        recurring basis as described at the time of purchase. You may cancel a
        subscription anytime unless stated otherwise.
      </p>

      <h2 className="text-2xl font-semibold mt-6 mb-3">6. Termination</h2>
      <p className="mb-4">
        We reserve the right to suspend or terminate your access to the Services
        at our discretion, including for violations of these Terms or harmful
        behavior. Upon termination, your right to use the Services will
        immediately cease.
      </p>

      <h2 className="text-2xl font-semibold mt-6 mb-3">7. Disclaimer of Warranties</h2>
      <p className="mb-4">
        Our Services are provided “as is” and “as available.” We make no
        warranties regarding reliability, accuracy, availability, or suitability
        of the Services for any purpose.
      </p>

      <h2 className="text-2xl font-semibold mt-6 mb-3">8. Limitation of Liability</h2>
      <p className="mb-4">
        To the fullest extent permitted by law, we are not liable for any direct,
        indirect, incidental, or consequential damages arising from your use of
        the Services.
      </p>

      <h2 className="text-2xl font-semibold mt-6 mb-3">9. Changes to Terms</h2>
      <p className="mb-4">
        We may update these Terms from time to time. Continued use of the
        Services constitutes acceptance of the updated Terms. The latest version
        will always be available on this page.
      </p>

      <h2 className="text-2xl font-semibold mt-6 mb-3">10. Contact Us</h2>
      <p className="mb-4">
        If you have questions or concerns about these Terms, please contact us at:
      </p>

      <p className="font-semibold">hello@zolaid.com</p>

      <p className="text-sm text-gray-500 mt-8">Last Updated: January 2025</p>
    </main>
      <SiteFooter />
    </div>
  );
}
